import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetSimilarFundsRequest extends BaseServiceRequest {
    constructor(fundticker, isEntitled = false) {
        super();
        super.addRequestUri("similarfunds.pb");
        super.addRequestParameter("fundticker", fundticker);
        super.addRequestParameter("isEntitled", isEntitled ? "1" : "0");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "SimilarFundsResponse";
    }
}

export default GetSimilarFundsRequest;
